import React from "react";
import { useLanguage } from "../../../../contexts";
import { P, useEnergia } from "../engine";
import { ConInstalacion, Notice, Section } from "../common/SectionCommon";
import "../common/common.scss";

const fmt = (v, d = 0) => P.fmt(v, d);

function TablaGuia({ filas, t }) {
  return (
    <div className="ep-table">
      <table>
        <thead><tr><th>{t("energy_performance_med_what_plant")}</th><th>{t("energy_performance_med_measure")}</th><th>{t("energy_performance_med_instrument")}</th><th>{t("energy_performance_med_frequency")}</th><th>{t("energy_performance_med_own_ref")}</th><th>{t("energy_performance_med_decision")}</th></tr></thead>
        <tbody>
          {filas.map(({ titulo, sub, g }, i) => (
            <tr key={i}>
              <td><strong>{titulo}</strong><div className="ep-section__note">{sub}</div></td>
              <td className="ep-section__note">{g.medir}</td>
              <td className="ep-section__note">{g.instrumento}</td>
              <td className="ep-section__note">{g.frecuencia}</td>
              <td><strong>{g.comparar}</strong></td>
              <td className="ep-section__note">{g.habilita}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

// Guía de medición y verificación (6.6 / 9.1.1): qué medir y contra qué referencia PROPIA (hoja 17).
export function MeasurementGuideView({ installation }) {
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;
  const vista = useEnergia(installation);
  return (
    <ConInstalacion installation={installation} vista={vista} t={t}>
      {(f) => {
        const nivel = (r) => (r === "continua" ? ["energy_performance_med_level2", "energy_performance_med_step2"] : r === "puntual" ? ["energy_performance_med_level1", "energy_performance_med_step1"] : ["energy_performance_med_level0", "energy_performance_med_step0"]);
        const grupos = new Map();
        (f.machinery || []).forEach((m) => {
          const g = P.guiaParaMaquina(m);
          if (!grupos.has(g.titulo)) grupos.set(g.titulo, { g, maquinas: [] });
          grupos.get(g.titulo).maquinas.push(m.nombre);
        });
        const nuevos = P.equiposSinCategoria(f);
        const doms = (f.operations || []).filter((o) => o.cat === "Doméstico");
        const sinMed = (f.seus || []).filter((u) => u.reliab === "factura");
        return (
          <div className="ep-screen">
            <h3 className="ep-screen__title">{t("energy_performance_med_title")}</h3>
            <p className="ep-screen__intro">{t("energy_performance_med_intro")}</p>

            <Section title={t("energy_performance_med_seu_levels")}>
              <div className="ep-table">
                <table>
                  <thead><tr><th>USE</th><th>{t("energy_performance_med_instrument")}</th><th>{t("energy_performance_seu_reliability")}</th><th>{t("energy_performance_iden_level")}</th><th>{t("energy_performance_med_next_step")}</th></tr></thead>
                  <tbody>{(f.seus || []).map((s) => {
                    const [n, paso] = nivel(s.reliab);
                    return <tr key={s.name}><td>{s.name}</td><td className="ep-section__note">{P.INSTRUMENT_BY_SEU[s.name] || t("energy_performance_med_instrument_tbd")}</td><td>{s.reliab}</td><td>{t(n)}</td><td className="ep-section__note">{t(paso)}</td></tr>;
                  })}</tbody>
                </table>
              </div>
            </Section>

            <Section title={t("energy_performance_med_by_machine")}>
              <TablaGuia t={t} filas={[...grupos.values()].map(({ g, maquinas }) => ({ titulo: g.titulo, sub: maquinas.join(" · "), g }))} />
            </Section>

            {nuevos.length > 0 && (
              <Notice titulo={t("energy_performance_med_new_equipment")}>
                {nuevos.map((m) => <div key={m.nombre}><strong>{m.nombre}</strong> — {t("energy_performance_med_new_equipment_text").replace("{kwh}", fmt(P.estimarConsumo(m) || 0))}</div>)}
              </Notice>
            )}

            <Section title={t("energy_performance_med_domestic")}>
              {doms.length ? (
                <TablaGuia t={t} filas={doms.map((o) => {
                  const ev = P.evalOperacion(o);
                  return { titulo: o.nombre, sub: `${fmt(o.consumo)} kWh/${t("energy_performance_year")} · ${fmt(ev.esp, ev.esp < 1 ? 3 : 2)} kWh/${o.unidad || "u"}`, g: P.guiaParaOperacionDom(o) };
                })} />
              ) : <Notice tipo="danger">{t("energy_performance_med_no_domestic")}</Notice>}
            </Section>

            <Section title={t("energy_performance_med_campaigns")}>
              {sinMed.length ? (
                <div className="ep-table">
                  <table>
                    <thead><tr><th>{t("energy_performance_med_seu_level0")}</th><th>{t("energy_performance_med_equipment")}</th><th>{t("energy_performance_med_duration")}</th><th>{t("energy_performance_med_validates")}</th></tr></thead>
                    <tbody>{sinMed.map((u) => {
                      const eq = (f.machinery || []).filter((m) => m.seu === u.name);
                      const kwh = eq.reduce((a, m) => a + (P.estimarConsumo(m) || 0), 0);
                      return <tr key={u.name}><td><strong>{u.name}</strong> ({u.share}%)</td><td className="ep-section__note">{eq.map((m) => m.nombre).join(" · ") || "—"}</td><td>{t("energy_performance_med_duration_value")}</td><td className="ep-section__note">{t("energy_performance_med_validates_value").replace("{kwh}", fmt(kwh))}</td></tr>;
                    })}</tbody>
                  </table>
                </div>
              ) : <p className="ep-section__note">{t("energy_performance_med_no_campaigns")}</p>}
            </Section>
          </div>
        );
      }}
    </ConInstalacion>
  );
}
